import { validateIBAN } from 'ibantools';

export const useValidations = () => {
    const isValidEmail = (email: string | undefined) => {
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        return email != undefined && emailRegex.test(email);
    };

    const isValidIban = (iban: string | undefined) => {
        if (!iban) return false;
        const cleanIban = iban.replaceAll(' ', '').toUpperCase();
        return validateIBAN(cleanIban).valid;
    };

    return { isValidEmail, isValidIban };
};
